import apiClient from '../api';

/**
 * Follow-Up Actions API Service
 * Endpoints para ações de retorno (follow-up) com magic links
 */

/**
 * Valida token de follow-up e retorna dados do participante + form schema
 * @param {string} token - Token do magic link
 * @returns {Promise<object>}
 */
export async function validateFollowUpToken(token) {
  const response = await apiClient.get(`/follow-up/validate-token/${token}`);
  return response.data;
}

/**
 * Submete dados do formulário de follow-up
 * @param {string} token - Token do magic link
 * @param {FormData|object} formData - Dados do formulário
 * @returns {Promise<object>}
 */
export async function submitFollowUpForm(token, formData) {
  if (formData instanceof FormData) {
    formData.append('token', token);
    const response = await apiClient.post('/follow-up/submit', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 120000 // 2 minutos para uploads
    });
    return response.data;
  }

  const response = await apiClient.post('/follow-up/submit', {
    ...formData,
    token
  });
  return response.data;
}

export default {
  validateFollowUpToken,
  submitFollowUpForm
};
